import React, { useContext } from 'react'

export const BotContext = React.createContext({})
export const FlowContext = React.createContext({
  id: '',
  starting_step_id: '',
  isNewUI: false,
  steps: {}
})

export const StepContext = React.createContext({
  stepId: '',
  isStartingStep: false
})

export const useFlowContext = () => useContext(FlowContext)
export const useStepContext = () => useContext(StepContext)
